
<template>
  <div name="registers" class="inner">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to=""> Resource Admin </router-link>
        <i class="carret fas fa-caret-right"></i> {{ title }}
      </template>

      <template v-slot:listitems>
        <li
          v-if="!newAddition"
          @click="deletion"
          v-tooltip="{
            content: 'Delete Activity',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Delete Activity"
          class="action-list-item inline-block bg-list-grey hover:opacity-100"
        >
          <i class="icon fas fa-trash-alt" title="Delete Activity"></i>
        </li>

        <li
          v-if="!newAddition"
          class="inline-block mx-4 text-2xl text-gray-400"
        >
          |
        </li>

        <li class="inline-block">
          <button
            @click="submitForm()"
            type="button"
            class="publish-button hover:opacity-75"
          >
            Publish Changes
          </button>
        </li>
      </template>
    </innertopbar>
    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <div class="w-full mx-auto grid grid grid-flow-col grid-cols-2 gap-10">
      <div class="mt-6 ml-8 p-6 bg-white rounded-lg mb-10">
        <form
          class="space-y-2 px-4"
          v-on:submit.prevent="submitUpload"
          ref="form"
        >
          <div class="grid grid-cols-1 space-y-2">
            <label
              class="text-sm font-bold text-gray-600 text-left tracking-wide"
              >Resource Title</label
            >

            <input
              class="p-3 mb-5 bg-white border border-gray-200 rounded h-36 focus:bg-white focus:outline-none"
              type=""
              v-model="name"
              placeholder="Enter title..."
            />
          </div>

          <div class="grid grid-cols-1 space-y-3 pt-4">
            <label class="text-sm font-bold text-gray-600 tracking-wide"
              >Attach Document</label
            >
            <p v-if="hasFile" class="font-bold text-red-400">
              Selected file {{ file.name }}
            </p>
            <div
              class="flex items-center justify-center w-full"
              v-on:click="showUpload()"
            >
              <label
                class="flex flex-col rounded-lg border-4 border-dashed w-full h-48 p-10 group text-center cursor-pointer"
              >
                <div
                  class="h-full w-full text-center flex flex-col items-center justify-center items-center"
                >
                  <div class="flex flex-auto max-h-32 w-2/5 mx-auto -mt-10">
                    <img
                      class="has-mask h-32 object-center p-2 mt-6"
                      src="/static/images/empty/document.png"
                      alt="Add document resource"
                    />
                  </div>
                  <p class="pointer-none text-gray-500">
                    <span class="text-sm">Click to select</span> a file from
                    your computer
                  </p>
                </div>
                <input
                  type="file"
                  class="hidden"
                  v-on:change="handleFileUpload()"
                  ref="file"
                />
              </label>
            </div>
          </div>
        </form>
      </div>

      <div class="p-6 pt-10 bg-white">
        <div
          style="width: 100%; text-align: center"
          class="spin-holder"
          v-if="loading"
        >
          <i class="spinner fa fa-atom fa-spin"></i>
          <p>Loading File</p>
        </div>

        <div v-if="!displayDocument && !loading" class="p-10 w-11/12">
          <h2 class="font-bold text-xl">The document is not available</h2>
          <p class="pt-2 font-semibold">
            This selected document is not currently available.
          </p>
          <p class="pt-2">
            We are constantly aiming to improve our product and adding more
            content so please try back again later or contact the Primary PE
            Passport office for further help or information.
          </p>
        </div>

        <div class="h-full w-full">
          <div v-if="displayDocument">
            <template v-if="isPDF && isImage == false">
              <pdf
                ref="myPdfComponent"
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="pdfsrc"
                class="w-1/2 h-full mx-auto"
              >
                <template slot="loading"> loading content here... </template>
              </pdf>
            </template>
            <iframe
              v-else-if="isImage == false"
              v-bind:src="pathUrl"
              width="100%"
              height="100%"
              class="pt-8"
              @load="fileLoaded"
              ref="reference"
            />
            <img
              :src="pathUrl"
              :alt="title"
              class="gallery-image"
              ref="reference"
              :title="title"
              @contextmenu.prevent="handler"
              v-else
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import { BaseService } from "@/services/school.service";
const innertopbar = () => import("@/components/InnerTopBar.vue");
const dropdown = () => import("@/components/admin/Dropdown.vue");
const savenotice = () => import("@/components/SaveNotice.vue");

const noaccess = () => import("@/components/admin/NoAccess.vue");

import pdfvuer from "pdfvuer";
import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";

export default {
  name: "registers",
  mixins: [fileResourceMixin],
  props: {
    resource: { type: Object, required: true },
  },
  computed: {
    title() {
      if (this.newAddition) {
        return "Create";
      } else {
        return this.name;
      }
    },
    hasFile() {
      return this.file.name != undefined && this.file.name.length > 3;
    },
    extension() {
      return this.url.split(".").pop();
    },
    isImage() {
      let imageExtensions = ["jpg", "png"];
      return imageExtensions.includes(this.extension);
    },
    displayDocument() {
      if (this.loading === false && this.hasError === false) {
        return true;
      }

      return false;
    },
    isPDF() {
      return this.extension === "pdf";
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      newAddition: false,

      pathUrl: "",
      displayKey: "library",
      name: "",
      isResourceComplete: false,
      file: {},
      selectedFormat: "document",

      hasError: false,
      numPages: null,
      pdfsrc: null,
      url: ""
    };
  },
  created() {
    this.loading = false;

    if (this.newAddition == false) {
      if (this.resource == undefined) {
        this.closeWindow();
        return;
      } else {
        if (this.selectedFormat == "document") {
          this.selectedFormat = this.selectedFormat + "s";
        }

        this.url =  this.resource.folder + "/" + this.resource.url
        if (this.isPDF) {
          this.loadData();
        } else {
          this.loadMedia();
        }
      }
    }
  },
  mounted() {},
  methods: {
    loadData() {
      setTimeout(() => {
        this.getFileDataByType(this.url, this.selectedFormat).then((result) => {
          const url = URL.createObjectURL(result.Body);
          this.pdfsrc = pdfvuer.createLoadingTask(url);
          this.pdfsrc.then((pdf) => {
            this.numPages = pdf.numPages;
          });
          this.loading = false;
        });
      }, 1000);
    },
    loadMedia() {
      this.hasError = false;
      setTimeout(() => {
        this.getFileByType(this.url, this.selectedFormat)
          .then((f) => {
            var encodedUrl = encodeURIComponent(f);
            let file = (this.pathUrl =
              this.isImage == true || this.extension == "pdf"
                ? f
                : "https://docs.google.com/viewer?url=" +
                  encodedUrl +
                  "&embedded=true");

            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log("ERROR", err);
          });
      }, 1000);
    },
    closeWindow() {
      this.$router.push({ name: "ResourceAdminLibrary" });
      window.scrollTo(0, 0);
    },
    submitForm() {
      // this.isSaving = true;
      // if (this.$refs.form.requestSubmit === undefined) {
      //   this.processActivity();
      // } else {
      //   this.$refs.form.requestSubmit();
      // }
    },
    submitActivity() {
      // if (
      //   this.name == "" ||
      //   this.selectedType.id === 0 ||
      //   this.selectedTerms.length === 0 ||
      //   this.selectedTimes.length === 0 ||
      //   this.selectedDays.length === 0
      // ) {
      //   this.alertDisplay();
      //   this.isSaving = false;
      // } else {
      //   this.processActivity();
      // }
    },
    alertDisplay() {
      this.$swal({
        title: "Please complete all fields",
        text: "You must enter a title and set a class to complete the form.",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result === true) {
          //this.processPupil();
        }
      });
    },
    processActivity() {
      // this.activity.title = this.name;
      // this.activity.session_type = this.selectedType.value;
      // this.activity.address = this.address;
      // this.activity.description = this.details;
      // this.activity.duration = parseInt(this.duration);
      // this.activity.weeks = parseInt(this.weeksCount);
      // this.activity.term = this.selectedTerms.join();
      // this.activity.weekday = this.selectedDays.join();
      // this.activity.timeframe = this.selectedTimes.join();
      // if (this.activity.identifier === undefined) {
      //   let calendarYear = calendarYearList().find((y) => y.current === true);
      //   this.activity.calendar_schoolyear = calendarYear.value;
      //   ActivityService.add(this.activity)
      //     .then((response) => {
      //       this.activity.identifier = response.data.identifier;
      //       this.completion();
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // } else {
      //   ActivityService.update(this.activity)
      //     .then((response) => this.completion(response.data))
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // }
    },
    completion(msg) {
      // var vm = this;
      // vm.pupilsRemoved.forEach((p) => {
      //   ActivityService.deletePupil(vm.activity, p).catch((err) => {
      //     console.log(err);
      //   });
      // });
      // vm.pupilsSelected.forEach((p) => {
      //   let payload = {
      //     activity_identifier: vm.activity.identifier,
      //     register_identifier: p.identifier,
      //   };
      //   ActivityService.addPupil(payload).catch((err) => {
      //     console.log(err);
      //   });
      // });
      // vm.evidencesRemoved.forEach((e) => {
      //   ActivityService.deleteEvidence(vm.activity, e).catch((err) => {
      //     console.log(err);
      //   });
      // });
      // this.isSaving = false;
      // this.$router.push({ name: "Activities", params: { msg: msg } });
      // window.scrollTo(0, 0);
    },
    failure(error) {
      this.$refs.saveNoticeTop.failed();
      this.$refs.saveNoticeBottom.failed();
      console.log("Activity update error " + error);
    },
    deletion() {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result) {
          this.processDelete();
        }
      });
    },
    processDelete() {
      // ActivityService.delete(this.activity)
      //   .then((response) => this.completion(response.data))
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
  },
  components: {
    innertopbar,
    dropdown,
    noaccess,
    savenotice,
     pdf: pdfvuer,
  },
};
</script>


<style scoped>
</style>
